'use client';

import { Link } from '@natu/next-link';
import { Button } from '@natu/ui/Button';
import { ButtonWithEvent } from '@natu/ui/Button/ButtonWithEvent';
import { DynamicIcon } from '@natu/ui/DynamicIcon';
import { usePageContext } from '@natu/utils/PageContextProvider';

interface ArticleCardButtonProps {
  articleLink: string;
}

export const ArticleCardButton = ({ articleLink }: ArticleCardButtonProps) => {
  const { isArticle } = usePageContext() || {};

  if (isArticle)
    return (
      <ButtonWithEvent
        event="E_click_blog_internal_link_banner"
        variant="outline-transparent"
        asChild
      >
        <Link
          href={articleLink}
          className="@xl:mt-14 mt-8 flex items-center gap-4 text-[13px] font-bold"
        >
          <span>CHECK THE ARTICLE</span>
          <DynamicIcon icon="arrowRight" />
        </Link>
      </ButtonWithEvent>
    );

  return (
    <Button variant="outline-transparent" asChild>
      <Link
        href={articleLink}
        className="@xl:mt-14 mt-8 flex items-center gap-4 text-[13px] font-bold"
      >
        <span>CHECK THE ARTICLE</span>
        <DynamicIcon icon="arrowRight" />
      </Link>
    </Button>
  );
};
